import PropTypes from "prop-types";
import React from "react";
import { AnnouncementsModalProvider } from "./AnnouncementsModalContext";
import { MessageEditorProvider } from "./MessageEditorContext";
import { ToasterProvider } from "./ToasterContext";

const providers = [AnnouncementsModalProvider, ToasterProvider, MessageEditorProvider];

function ContextWrapper({ children, contexts }) {
  if (!contexts.length) return children;

  const [Component, ...rest] = contexts;

  return (
    <ContextWrapper contexts={rest}>
      <Component>{children}</Component>
    </ContextWrapper>
  );
}

ContextWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.object]).isRequired,
  contexts: PropTypes.array.isRequired,
};

function GlobalContext({ children }) {
  return <ContextWrapper contexts={providers}>{children}</ContextWrapper>;
}

GlobalContext.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.object]).isRequired,
};

export default GlobalContext;
